import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { GridToolbarLayoutsButton } from '@price-for-profit/data-grid';
import { GridToolbarRefreshButton } from 'shared/components';

const localStorageName = 'insight.wps.freight-table-configurations';

interface ToolbarProps {
  invalidate(): void;
  updatedAt: Date | null;
}
export function TableToolbar({ invalidate, updatedAt }: ToolbarProps) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarLayoutsButton localStorageName={localStorageName} />
      <GridToolbarExport />
      {updatedAt ? <GridToolbarRefreshButton refresh={invalidate} updatedAt={updatedAt} /> : null}
    </GridToolbarContainer>
  );
}
